module.exports = __webpack_public_path__ + "img/344-59460c.png";